import styled from 'styled-components';

// A checkbox or radio and the help icon that explains it, kept on one line.
export default styled.div`
  display: flex;
  align-items: center;
`;
